/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WaitListImport } from './routes/wait-list'
import { Route as SsoCallbackImport } from './routes/sso-callback'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SettingsImport } from './routes/settings'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as LogInImport } from './routes/log-in'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as AppImport } from './routes/app'
import { Route as IndexImport } from './routes/index'
import { Route as AppIndexImport } from './routes/app/index'
import { Route as TrialActivateImport } from './routes/trial/activate'
import { Route as TasksNewImport } from './routes/tasks/new'
import { Route as TasksTaskIdImport } from './routes/tasks/$taskId'
import { Route as SignupMcpImport } from './routes/signup/mcp'
import { Route as SignUpEmailImport } from './routes/sign-up_.email'
import { Route as ResetPasswordTokenImport } from './routes/reset-password/$token'
import { Route as PreviewIdImport } from './routes/preview/$id'
import { Route as OnboardingProfileImport } from './routes/onboarding/profile'
import { Route as OnboardingMembershipImport } from './routes/onboarding/membership'
import { Route as OnboardingCompleteImport } from './routes/onboarding/complete'
import { Route as AppTrendingTasksImport } from './routes/app/trending-tasks'
import { Route as AppTaskImport } from './routes/app/task'
import { Route as AppSettingsImport } from './routes/app/settings'
import { Route as AppProfileImport } from './routes/app/profile'
import { Route as AppHomeImport } from './routes/app/home'
import { Route as AppDiscoverImport } from './routes/app/discover'
import { Route as AcceptInviteInviteIdImport } from './routes/accept-invite/$inviteId'
import { Route as OptionsOptionSheetIdIndexImport } from './routes/options/$optionSheetId/index'
import { Route as AppTaskIndexImport } from './routes/app/task/index'
import { Route as AppSettingsIndexImport } from './routes/app/settings/index'
import { Route as AppRecurrenceIndexImport } from './routes/app/recurrence/index'
import { Route as AppLetterRecommendationIndexImport } from './routes/app/letter-recommendation/index'
import { Route as AppCalendarRecurrenceIndexImport } from './routes/app/calendar-recurrence/index'
import { Route as SignupMcpSuccessImport } from './routes/signup/mcp_.success'
import { Route as SignupMcpCompleteImport } from './routes/signup/mcp_.complete'
import { Route as AppTaskTaskIdImport } from './routes/app/task/$taskId'
import { Route as AppSettingsPaymentsImport } from './routes/app/settings/payments'
import { Route as AppSettingsNotificationsImport } from './routes/app/settings/notifications'
import { Route as AppSettingsManageHouseholdImport } from './routes/app/settings/manage-household'
import { Route as AppSettingsInviteFriendsImport } from './routes/app/settings/invite-friends'
import { Route as AppSettingsFeedbackImport } from './routes/app/settings/feedback'
import { Route as AppSettingsEmailPasswordImport } from './routes/app/settings/email-password'
import { Route as AppSettingsDownloadAppImport } from './routes/app/settings/download-app'
import { Route as AppSettingsCalendarImport } from './routes/app/settings/calendar'
import { Route as AppRecurrenceCreateImport } from './routes/app/recurrence/create'
import { Route as AppRecurrenceRecurrenceIdImport } from './routes/app/recurrence/$recurrenceId'
import { Route as AppLetterRecommendationLetterRecommendationIdImport } from './routes/app/letter-recommendation/$letterRecommendationId'
import { Route as AppDraftTaskCreateImport } from './routes/app/draft-task/create'
import { Route as AppDraftTaskDraftTaskIdImport } from './routes/app/draft-task/$draftTaskId'
import { Route as AppOptionSheetOptionSheetIdIndexImport } from './routes/app/option-sheet/$optionSheetId/index'

// Create/Update Routes

const WaitListRoute = WaitListImport.update({
  path: '/wait-list',
  getParentRoute: () => rootRoute,
} as any)

const SsoCallbackRoute = SsoCallbackImport.update({
  path: '/sso-callback',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LogInRoute = LogInImport.update({
  path: '/log-in',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const TrialActivateRoute = TrialActivateImport.update({
  path: '/trial/activate',
  getParentRoute: () => rootRoute,
} as any)

const TasksNewRoute = TasksNewImport.update({
  path: '/tasks/new',
  getParentRoute: () => rootRoute,
} as any)

const TasksTaskIdRoute = TasksTaskIdImport.update({
  path: '/tasks/$taskId',
  getParentRoute: () => rootRoute,
} as any)

const SignupMcpRoute = SignupMcpImport.update({
  path: '/signup/mcp',
  getParentRoute: () => rootRoute,
} as any)

const SignUpEmailRoute = SignUpEmailImport.update({
  path: '/sign-up/email',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordTokenRoute = ResetPasswordTokenImport.update({
  path: '/reset-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const PreviewIdRoute = PreviewIdImport.update({
  path: '/preview/$id',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingProfileRoute = OnboardingProfileImport.update({
  path: '/onboarding/profile',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingMembershipRoute = OnboardingMembershipImport.update({
  path: '/onboarding/membership',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingCompleteRoute = OnboardingCompleteImport.update({
  path: '/onboarding/complete',
  getParentRoute: () => rootRoute,
} as any)

const AppTrendingTasksRoute = AppTrendingTasksImport.update({
  path: '/trending-tasks',
  getParentRoute: () => AppRoute,
} as any)

const AppTaskRoute = AppTaskImport.update({
  path: '/task',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsRoute = AppSettingsImport.update({
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppProfileRoute = AppProfileImport.update({
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AppDiscoverRoute = AppDiscoverImport.update({
  path: '/discover',
  getParentRoute: () => AppRoute,
} as any)

const AcceptInviteInviteIdRoute = AcceptInviteInviteIdImport.update({
  path: '/accept-invite/$inviteId',
  getParentRoute: () => rootRoute,
} as any)

const OptionsOptionSheetIdIndexRoute = OptionsOptionSheetIdIndexImport.update({
  path: '/options/$optionSheetId/',
  getParentRoute: () => rootRoute,
} as any)

const AppTaskIndexRoute = AppTaskIndexImport.update({
  path: '/',
  getParentRoute: () => AppTaskRoute,
} as any)

const AppSettingsIndexRoute = AppSettingsIndexImport.update({
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppRecurrenceIndexRoute = AppRecurrenceIndexImport.update({
  path: '/recurrence/',
  getParentRoute: () => AppRoute,
} as any)

const AppLetterRecommendationIndexRoute =
  AppLetterRecommendationIndexImport.update({
    path: '/letter-recommendation/',
    getParentRoute: () => AppRoute,
  } as any)

const AppCalendarRecurrenceIndexRoute = AppCalendarRecurrenceIndexImport.update(
  {
    path: '/calendar-recurrence/',
    getParentRoute: () => AppRoute,
  } as any,
)

const SignupMcpSuccessRoute = SignupMcpSuccessImport.update({
  path: '/signup/mcp/success',
  getParentRoute: () => rootRoute,
} as any)

const SignupMcpCompleteRoute = SignupMcpCompleteImport.update({
  path: '/signup/mcp/complete',
  getParentRoute: () => rootRoute,
} as any)

const AppTaskTaskIdRoute = AppTaskTaskIdImport.update({
  path: '/$taskId',
  getParentRoute: () => AppTaskRoute,
} as any)

const AppSettingsPaymentsRoute = AppSettingsPaymentsImport.update({
  path: '/payments',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsNotificationsRoute = AppSettingsNotificationsImport.update({
  path: '/notifications',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsManageHouseholdRoute = AppSettingsManageHouseholdImport.update(
  {
    path: '/manage-household',
    getParentRoute: () => AppSettingsRoute,
  } as any,
)

const AppSettingsInviteFriendsRoute = AppSettingsInviteFriendsImport.update({
  path: '/invite-friends',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsFeedbackRoute = AppSettingsFeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsEmailPasswordRoute = AppSettingsEmailPasswordImport.update({
  path: '/email-password',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsDownloadAppRoute = AppSettingsDownloadAppImport.update({
  path: '/download-app',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsCalendarRoute = AppSettingsCalendarImport.update({
  path: '/calendar',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppRecurrenceCreateRoute = AppRecurrenceCreateImport.update({
  path: '/recurrence/create',
  getParentRoute: () => AppRoute,
} as any)

const AppRecurrenceRecurrenceIdRoute = AppRecurrenceRecurrenceIdImport.update({
  path: '/recurrence/$recurrenceId',
  getParentRoute: () => AppRoute,
} as any)

const AppLetterRecommendationLetterRecommendationIdRoute =
  AppLetterRecommendationLetterRecommendationIdImport.update({
    path: '/letter-recommendation/$letterRecommendationId',
    getParentRoute: () => AppRoute,
  } as any)

const AppDraftTaskCreateRoute = AppDraftTaskCreateImport.update({
  path: '/draft-task/create',
  getParentRoute: () => AppRoute,
} as any)

const AppDraftTaskDraftTaskIdRoute = AppDraftTaskDraftTaskIdImport.update({
  path: '/draft-task/$draftTaskId',
  getParentRoute: () => AppRoute,
} as any)

const AppOptionSheetOptionSheetIdIndexRoute =
  AppOptionSheetOptionSheetIdIndexImport.update({
    path: '/option-sheet/$optionSheetId/',
    getParentRoute: () => AppRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/log-in': {
      id: '/log-in'
      path: '/log-in'
      fullPath: '/log-in'
      preLoaderRoute: typeof LogInImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackImport
      parentRoute: typeof rootRoute
    }
    '/wait-list': {
      id: '/wait-list'
      path: '/wait-list'
      fullPath: '/wait-list'
      preLoaderRoute: typeof WaitListImport
      parentRoute: typeof rootRoute
    }
    '/accept-invite/$inviteId': {
      id: '/accept-invite/$inviteId'
      path: '/accept-invite/$inviteId'
      fullPath: '/accept-invite/$inviteId'
      preLoaderRoute: typeof AcceptInviteInviteIdImport
      parentRoute: typeof rootRoute
    }
    '/app/discover': {
      id: '/app/discover'
      path: '/discover'
      fullPath: '/app/discover'
      preLoaderRoute: typeof AppDiscoverImport
      parentRoute: typeof AppImport
    }
    '/app/home': {
      id: '/app/home'
      path: '/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileImport
      parentRoute: typeof AppImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/app/task': {
      id: '/app/task'
      path: '/task'
      fullPath: '/app/task'
      preLoaderRoute: typeof AppTaskImport
      parentRoute: typeof AppImport
    }
    '/app/trending-tasks': {
      id: '/app/trending-tasks'
      path: '/trending-tasks'
      fullPath: '/app/trending-tasks'
      preLoaderRoute: typeof AppTrendingTasksImport
      parentRoute: typeof AppImport
    }
    '/onboarding/complete': {
      id: '/onboarding/complete'
      path: '/onboarding/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof OnboardingCompleteImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/membership': {
      id: '/onboarding/membership'
      path: '/onboarding/membership'
      fullPath: '/onboarding/membership'
      preLoaderRoute: typeof OnboardingMembershipImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/onboarding/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileImport
      parentRoute: typeof rootRoute
    }
    '/preview/$id': {
      id: '/preview/$id'
      path: '/preview/$id'
      fullPath: '/preview/$id'
      preLoaderRoute: typeof PreviewIdImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/sign-up/email': {
      id: '/sign-up/email'
      path: '/sign-up/email'
      fullPath: '/sign-up/email'
      preLoaderRoute: typeof SignUpEmailImport
      parentRoute: typeof rootRoute
    }
    '/signup/mcp': {
      id: '/signup/mcp'
      path: '/signup/mcp'
      fullPath: '/signup/mcp'
      preLoaderRoute: typeof SignupMcpImport
      parentRoute: typeof rootRoute
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdImport
      parentRoute: typeof rootRoute
    }
    '/tasks/new': {
      id: '/tasks/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof TasksNewImport
      parentRoute: typeof rootRoute
    }
    '/trial/activate': {
      id: '/trial/activate'
      path: '/trial/activate'
      fullPath: '/trial/activate'
      preLoaderRoute: typeof TrialActivateImport
      parentRoute: typeof rootRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/app/draft-task/$draftTaskId': {
      id: '/app/draft-task/$draftTaskId'
      path: '/draft-task/$draftTaskId'
      fullPath: '/app/draft-task/$draftTaskId'
      preLoaderRoute: typeof AppDraftTaskDraftTaskIdImport
      parentRoute: typeof AppImport
    }
    '/app/draft-task/create': {
      id: '/app/draft-task/create'
      path: '/draft-task/create'
      fullPath: '/app/draft-task/create'
      preLoaderRoute: typeof AppDraftTaskCreateImport
      parentRoute: typeof AppImport
    }
    '/app/letter-recommendation/$letterRecommendationId': {
      id: '/app/letter-recommendation/$letterRecommendationId'
      path: '/letter-recommendation/$letterRecommendationId'
      fullPath: '/app/letter-recommendation/$letterRecommendationId'
      preLoaderRoute: typeof AppLetterRecommendationLetterRecommendationIdImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/$recurrenceId': {
      id: '/app/recurrence/$recurrenceId'
      path: '/recurrence/$recurrenceId'
      fullPath: '/app/recurrence/$recurrenceId'
      preLoaderRoute: typeof AppRecurrenceRecurrenceIdImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/create': {
      id: '/app/recurrence/create'
      path: '/recurrence/create'
      fullPath: '/app/recurrence/create'
      preLoaderRoute: typeof AppRecurrenceCreateImport
      parentRoute: typeof AppImport
    }
    '/app/settings/calendar': {
      id: '/app/settings/calendar'
      path: '/calendar'
      fullPath: '/app/settings/calendar'
      preLoaderRoute: typeof AppSettingsCalendarImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/download-app': {
      id: '/app/settings/download-app'
      path: '/download-app'
      fullPath: '/app/settings/download-app'
      preLoaderRoute: typeof AppSettingsDownloadAppImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/email-password': {
      id: '/app/settings/email-password'
      path: '/email-password'
      fullPath: '/app/settings/email-password'
      preLoaderRoute: typeof AppSettingsEmailPasswordImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/feedback': {
      id: '/app/settings/feedback'
      path: '/feedback'
      fullPath: '/app/settings/feedback'
      preLoaderRoute: typeof AppSettingsFeedbackImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/invite-friends': {
      id: '/app/settings/invite-friends'
      path: '/invite-friends'
      fullPath: '/app/settings/invite-friends'
      preLoaderRoute: typeof AppSettingsInviteFriendsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/manage-household': {
      id: '/app/settings/manage-household'
      path: '/manage-household'
      fullPath: '/app/settings/manage-household'
      preLoaderRoute: typeof AppSettingsManageHouseholdImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/notifications': {
      id: '/app/settings/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/payments': {
      id: '/app/settings/payments'
      path: '/payments'
      fullPath: '/app/settings/payments'
      preLoaderRoute: typeof AppSettingsPaymentsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/task/$taskId': {
      id: '/app/task/$taskId'
      path: '/$taskId'
      fullPath: '/app/task/$taskId'
      preLoaderRoute: typeof AppTaskTaskIdImport
      parentRoute: typeof AppTaskImport
    }
    '/signup/mcp/complete': {
      id: '/signup/mcp/complete'
      path: '/signup/mcp/complete'
      fullPath: '/signup/mcp/complete'
      preLoaderRoute: typeof SignupMcpCompleteImport
      parentRoute: typeof rootRoute
    }
    '/signup/mcp/success': {
      id: '/signup/mcp/success'
      path: '/signup/mcp/success'
      fullPath: '/signup/mcp/success'
      preLoaderRoute: typeof SignupMcpSuccessImport
      parentRoute: typeof rootRoute
    }
    '/app/calendar-recurrence/': {
      id: '/app/calendar-recurrence/'
      path: '/calendar-recurrence'
      fullPath: '/app/calendar-recurrence'
      preLoaderRoute: typeof AppCalendarRecurrenceIndexImport
      parentRoute: typeof AppImport
    }
    '/app/letter-recommendation/': {
      id: '/app/letter-recommendation/'
      path: '/letter-recommendation'
      fullPath: '/app/letter-recommendation'
      preLoaderRoute: typeof AppLetterRecommendationIndexImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/': {
      id: '/app/recurrence/'
      path: '/recurrence'
      fullPath: '/app/recurrence'
      preLoaderRoute: typeof AppRecurrenceIndexImport
      parentRoute: typeof AppImport
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/task/': {
      id: '/app/task/'
      path: '/'
      fullPath: '/app/task/'
      preLoaderRoute: typeof AppTaskIndexImport
      parentRoute: typeof AppTaskImport
    }
    '/options/$optionSheetId/': {
      id: '/options/$optionSheetId/'
      path: '/options/$optionSheetId'
      fullPath: '/options/$optionSheetId'
      preLoaderRoute: typeof OptionsOptionSheetIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/app/option-sheet/$optionSheetId/': {
      id: '/app/option-sheet/$optionSheetId/'
      path: '/option-sheet/$optionSheetId'
      fullPath: '/app/option-sheet/$optionSheetId'
      preLoaderRoute: typeof AppOptionSheetOptionSheetIdIndexImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AppRoute: AppRoute.addChildren({
    AppDiscoverRoute,
    AppHomeRoute,
    AppProfileRoute,
    AppSettingsRoute: AppSettingsRoute.addChildren({
      AppSettingsCalendarRoute,
      AppSettingsDownloadAppRoute,
      AppSettingsEmailPasswordRoute,
      AppSettingsFeedbackRoute,
      AppSettingsInviteFriendsRoute,
      AppSettingsManageHouseholdRoute,
      AppSettingsNotificationsRoute,
      AppSettingsPaymentsRoute,
      AppSettingsIndexRoute,
    }),
    AppTaskRoute: AppTaskRoute.addChildren({
      AppTaskTaskIdRoute,
      AppTaskIndexRoute,
    }),
    AppTrendingTasksRoute,
    AppIndexRoute,
    AppDraftTaskDraftTaskIdRoute,
    AppDraftTaskCreateRoute,
    AppLetterRecommendationLetterRecommendationIdRoute,
    AppRecurrenceRecurrenceIdRoute,
    AppRecurrenceCreateRoute,
    AppCalendarRecurrenceIndexRoute,
    AppLetterRecommendationIndexRoute,
    AppRecurrenceIndexRoute,
    AppOptionSheetOptionSheetIdIndexRoute,
  }),
  ForgotPasswordRoute,
  LogInRoute,
  LoginRoute,
  LogoutRoute,
  SettingsRoute,
  SignUpRoute,
  SsoCallbackRoute,
  WaitListRoute,
  AcceptInviteInviteIdRoute,
  OnboardingCompleteRoute,
  OnboardingMembershipRoute,
  OnboardingProfileRoute,
  PreviewIdRoute,
  ResetPasswordTokenRoute,
  SignUpEmailRoute,
  SignupMcpRoute,
  TasksTaskIdRoute,
  TasksNewRoute,
  TrialActivateRoute,
  SignupMcpCompleteRoute,
  SignupMcpSuccessRoute,
  OptionsOptionSheetIdIndexRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/forgot-password",
        "/log-in",
        "/login",
        "/logout",
        "/settings",
        "/sign-up",
        "/sso-callback",
        "/wait-list",
        "/accept-invite/$inviteId",
        "/onboarding/complete",
        "/onboarding/membership",
        "/onboarding/profile",
        "/preview/$id",
        "/reset-password/$token",
        "/sign-up/email",
        "/signup/mcp",
        "/tasks/$taskId",
        "/tasks/new",
        "/trial/activate",
        "/signup/mcp/complete",
        "/signup/mcp/success",
        "/options/$optionSheetId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/app": {
      "filePath": "app.tsx",
      "children": [
        "/app/discover",
        "/app/home",
        "/app/profile",
        "/app/settings",
        "/app/task",
        "/app/trending-tasks",
        "/app/",
        "/app/draft-task/$draftTaskId",
        "/app/draft-task/create",
        "/app/letter-recommendation/$letterRecommendationId",
        "/app/recurrence/$recurrenceId",
        "/app/recurrence/create",
        "/app/calendar-recurrence/",
        "/app/letter-recommendation/",
        "/app/recurrence/",
        "/app/option-sheet/$optionSheetId/"
      ]
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/log-in": {
      "filePath": "log-in.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/sso-callback": {
      "filePath": "sso-callback.tsx"
    },
    "/wait-list": {
      "filePath": "wait-list.tsx"
    },
    "/accept-invite/$inviteId": {
      "filePath": "accept-invite/$inviteId.tsx"
    },
    "/app/discover": {
      "filePath": "app/discover.tsx",
      "parent": "/app"
    },
    "/app/home": {
      "filePath": "app/home.tsx",
      "parent": "/app"
    },
    "/app/profile": {
      "filePath": "app/profile.tsx",
      "parent": "/app"
    },
    "/app/settings": {
      "filePath": "app/settings.tsx",
      "parent": "/app",
      "children": [
        "/app/settings/calendar",
        "/app/settings/download-app",
        "/app/settings/email-password",
        "/app/settings/feedback",
        "/app/settings/invite-friends",
        "/app/settings/manage-household",
        "/app/settings/notifications",
        "/app/settings/payments",
        "/app/settings/"
      ]
    },
    "/app/task": {
      "filePath": "app/task.tsx",
      "parent": "/app",
      "children": [
        "/app/task/$taskId",
        "/app/task/"
      ]
    },
    "/app/trending-tasks": {
      "filePath": "app/trending-tasks.tsx",
      "parent": "/app"
    },
    "/onboarding/complete": {
      "filePath": "onboarding/complete.tsx"
    },
    "/onboarding/membership": {
      "filePath": "onboarding/membership.tsx"
    },
    "/onboarding/profile": {
      "filePath": "onboarding/profile.tsx"
    },
    "/preview/$id": {
      "filePath": "preview/$id.tsx"
    },
    "/reset-password/$token": {
      "filePath": "reset-password/$token.tsx"
    },
    "/sign-up/email": {
      "filePath": "sign-up_.email.tsx"
    },
    "/signup/mcp": {
      "filePath": "signup/mcp.tsx"
    },
    "/tasks/$taskId": {
      "filePath": "tasks/$taskId.tsx"
    },
    "/tasks/new": {
      "filePath": "tasks/new.tsx"
    },
    "/trial/activate": {
      "filePath": "trial/activate.tsx"
    },
    "/app/": {
      "filePath": "app/index.tsx",
      "parent": "/app"
    },
    "/app/draft-task/$draftTaskId": {
      "filePath": "app/draft-task/$draftTaskId.tsx",
      "parent": "/app"
    },
    "/app/draft-task/create": {
      "filePath": "app/draft-task/create.tsx",
      "parent": "/app"
    },
    "/app/letter-recommendation/$letterRecommendationId": {
      "filePath": "app/letter-recommendation/$letterRecommendationId.tsx",
      "parent": "/app"
    },
    "/app/recurrence/$recurrenceId": {
      "filePath": "app/recurrence/$recurrenceId.tsx",
      "parent": "/app"
    },
    "/app/recurrence/create": {
      "filePath": "app/recurrence/create.tsx",
      "parent": "/app"
    },
    "/app/settings/calendar": {
      "filePath": "app/settings/calendar.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/download-app": {
      "filePath": "app/settings/download-app.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/email-password": {
      "filePath": "app/settings/email-password.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/feedback": {
      "filePath": "app/settings/feedback.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/invite-friends": {
      "filePath": "app/settings/invite-friends.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/manage-household": {
      "filePath": "app/settings/manage-household.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/notifications": {
      "filePath": "app/settings/notifications.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/payments": {
      "filePath": "app/settings/payments.tsx",
      "parent": "/app/settings"
    },
    "/app/task/$taskId": {
      "filePath": "app/task/$taskId.tsx",
      "parent": "/app/task"
    },
    "/signup/mcp/complete": {
      "filePath": "signup/mcp_.complete.tsx"
    },
    "/signup/mcp/success": {
      "filePath": "signup/mcp_.success.tsx"
    },
    "/app/calendar-recurrence/": {
      "filePath": "app/calendar-recurrence/index.tsx",
      "parent": "/app"
    },
    "/app/letter-recommendation/": {
      "filePath": "app/letter-recommendation/index.tsx",
      "parent": "/app"
    },
    "/app/recurrence/": {
      "filePath": "app/recurrence/index.tsx",
      "parent": "/app"
    },
    "/app/settings/": {
      "filePath": "app/settings/index.tsx",
      "parent": "/app/settings"
    },
    "/app/task/": {
      "filePath": "app/task/index.tsx",
      "parent": "/app/task"
    },
    "/options/$optionSheetId/": {
      "filePath": "options/$optionSheetId/index.tsx"
    },
    "/app/option-sheet/$optionSheetId/": {
      "filePath": "app/option-sheet/$optionSheetId/index.tsx",
      "parent": "/app"
    }
  }
}
ROUTE_MANIFEST_END */
